import { get } from "svelte/store";
import { attachmentsStore } from "../../../../../svelte/api-stores/attachments-store";
import {
  getUser,
  largePOST,
  showToast,
  wrappedPost,
} from "../../general/utils";

let currentFile;
let allAttachments = null;
let candidateTemplatesRef = null;
const storedTemplates = {};
let currentAttachmentIdsStore = null;

const iconMapping = {
  jpg: "image-icon.jpg",
  jpeg: "image-icon.jpg",
  png: "image-icon.jpg",
  gif: "image-icon.jpg",
  tif: "image-icon.jpg",
  tiff: "image-icon.jpg",
  heic: "image-icon.jpg",
  pdf: "pdf-icon.jpg",
  doc: "word-icon.jpg",
  docx: "word-icon.jpg",
  ppt: "powerpoint-icon.jpg",
  pptx: "powerpoint-icon.jpg",
  odp: "powerpoint-icon.jpg",
  xls: "excel-icon.jpg",
  xlsx: "excel-icon.jpg",
  csv: "csv-icon.jpg",
  txt: "text-icon.jpg",
};

const shortenText = (text, maxLength) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

const updateTarget = (targetArray, fId) =>
  targetArray.filter((id) => id !== fId);

const renderAttachments = ({
  templateId = "",
  attachmentIds = [],
  candidateTemplates = {},
}) => {
  if (candidateTemplates === "useRef") {
    const matchingTemplate = candidateTemplatesRef.find(
      (x) => x.templateId === templateId,
    );
    matchingTemplate.attachmentIds = attachmentIds;
    templateId = matchingTemplate.id;
  } else candidateTemplatesRef = candidateTemplates;

  const filteredAttachments = allAttachments.filter((attachment) =>
    attachmentIds.includes(attachment.attachmentId),
  );

  const attachmentsCol = $(`#${templateId}-attachmentsCol`);
  const attachmentsContainer = attachmentsCol.children(
    ".attachments-container",
  );

  attachmentsCol.toggle(attachmentIds.length > 0);
  attachmentsContainer.empty();

  filteredAttachments.forEach((attachment) => {
    const shortFilename = shortenText(attachment.filename, 7);

    const split = attachment.filename.split(".");

    const fileExtension = split.length > 1 ? split.at(-1).toLowerCase() : null;

    const iconToShow = iconMapping[fileExtension] || "default-icon.jpg";

    attachmentsContainer.append(`
        <div class="attachment-wrapper" data-id="attachment-${attachment.attachmentId}">
          <a href="${attachment.url}" target="_blank">
            <img class="attachment-icon" src="./assets/img/icons/${iconToShow}" alt="${attachment.filename}">
            <p data-toggle="tooltip" data-placement="bottom" title="${attachment.filename}">${shortFilename}</p>
          </a>
          <i data-template-id="${templateId}" data-attachment-id="${attachment.attachmentId}" class="fa-solid fa-circle-xmark close-icon" data-toggle="tooltip" title="Remove attachment"></i>
        </div>
      `);

    $('.close-icon[data-toggle="tooltip"]')
      .tooltip("dispose")
      .tooltip({ html: true, target: "hover" });
  });
};

const addOrRemoveAttachment = ({ event, type, fileId, targetTemplateId }) => {
  let templateAttachments;

  if (currentAttachmentIdsStore) {
    templateAttachments = get(currentAttachmentIdsStore);
  } else if (candidateTemplatesRef) {
    templateAttachments = candidateTemplatesRef.find(
      (x) => x.id === targetTemplateId,
    ).attachmentIds;
  } else {
    templateAttachments = storedTemplates[targetTemplateId];
  }

  if (type === "add") {
    if (templateAttachments.includes(fileId)) {
      $("#attachFileModalContent").addClass("background-filter");
      bootbox.dialog({
        message: "This file has already been attached to this step.",
        buttons: {
          ok: {
            label: "OK",
            className: "btn-light btn-sm",
            callback: () =>
              $("#attachFileModalContent").removeClass("background-filter"),
          },
        },
      });
      return;
    }
    if (currentAttachmentIdsStore) {
      currentAttachmentIdsStore.update((x) => [...x, fileId]);
    } else {
      templateAttachments.push(fileId);
    }

    $("#attachFileModal").modal("hide");
  }

  if (type === "remove") {
    $(event.target).tooltip("hide");
    if (currentAttachmentIdsStore) {
      currentAttachmentIdsStore.update((x) => x.filter((id) => id !== fileId));
    } else if (candidateTemplatesRef) {
      const template = candidateTemplatesRef.find(
        (x) => x.id === targetTemplateId,
      );
      template.attachmentIds = updateTarget(template.attachmentIds, fileId);
    } else
      storedTemplates[targetTemplateId] = updateTarget(
        storedTemplates[targetTemplateId],
        fileId,
      );
  }

  $(`#tab-${targetTemplateId}`).trigger("attachmentChanged");

  renderAttachments({
    templateId: targetTemplateId,
    attachmentIds: candidateTemplatesRef
      ? candidateTemplatesRef.find((x) => x.id === targetTemplateId)
          .attachmentIds
      : storedTemplates[targetTemplateId],
    candidateTemplates: candidateTemplatesRef,
  });
};

export const initTemplates = async ({
  type = "",
  key = "",
  templateData = {},
  attachmentIds = [],
  templateId = "",
  candidateTemplates = {},
}) => {
  await attachmentsStore.once();

  if (type === "single") {
    storedTemplates[key] = attachmentIds;
    renderAttachments({
      templateId: key,
      attachmentIds,
      candidateTemplates: null,
    });
  }

  if (type === "campaign")
    Object.entries(templateData).forEach(([k, template]) => {
      if (template.attachmentIds) {
        storedTemplates[k] = template.attachmentIds;
        renderAttachments({
          templateId: k,
          attachmentIds: template.attachmentIds,
          candidateTemplates: null,
        });
      }
    });

  if (type === "outreach")
    renderAttachments({
      templateId,
      attachmentIds,
      candidateTemplates,
    });
};

const deleteAttachment = (item) => {
  $("#attachFileModalContent").addClass("background-filter");
  bootbox.dialog({
    message: `Are you sure you would like to delete "${item.filename}?"`,
    buttons: {
      cancel: {
        label: "Cancel",
        className: "btn-light btn-sm",
        callback: () =>
          $("#attachFileModalContent").removeClass("background-filter"),
      },
      change: {
        label: "Delete",
        className: "btn-primary btn-sm",
        callback: () =>
          wrappedPost({
            url: "/api/attachments/delete",
            data: JSON.stringify({ attachmentId: item.id }),
            success: () => {
              $("#attachFileModalContent").removeClass("background-filter");
              showToast({
                title: `Successfully deleted "${item.filename}"`,
                type: "success",
              });
            },
            error: () => {
              $("#attachFileModalContent").removeClass("background-filter");
              showToast({
                title: `Failed to delete "${item.filename}"`,
                subtitle:
                  "Please try again or contact support if the issue persists",
                type: "danger",
              });
            },
          }),
      },
    },
  });
};

const refreshAttachments = () => {
  $("#selectAttachments ul").html("");
  const attachments = allAttachments.filter(
    (x) => x.deleted !== true && x.creatorUserId === getUser().userId,
  );
  $("#submitAttachFileModal").toggleClass("hidden", attachments.length === 0);

  attachments
    .sort((a, b) => b.timestamp - a.timestamp)
    .forEach((item) => {
      $("#selectAttachments ul").append(
        `<li data-id="${item.attachmentId}" class="attachment" value="${item.url}">${item.filename}<i data-id="${item.attachmentId}" data-filename="${item.filename}" class="delete-button fa-regular fa-trash-can ml-3"></i></li>`,
      );
    });

  const button = $("#selectAttachmentsButton");

  $(button).text(
    attachments[0]
      ? shortenText(attachments[0].filename, 25)
      : "No attachments",
  );
  button.prop("disabled", !attachments[0]);
  [currentFile] = attachments;

  $(".attachment").on("click", (e) => {
    $(button).text(e.target.innerText);
    currentFile = attachments.find(
      (item) => item.attachmentId === e.target.dataset.id,
    );
  });

  $(".attachment .delete-button").on("click", (e) => {
    e.stopPropagation();
    deleteAttachment(e.target.dataset);
  });
};

const insertLinkedText = (fileUrl, linkLabel) => {
  const customButtonHtml = `<a href="https://${fileUrl
    .replace("http://", "")
    .replace("https://", "")}" target="_blank">${linkLabel || "link"}</a>`;
  tinymce.activeEditor.insertContent(customButtonHtml);
  $("#attachFileModal").modal("hide");
};

export const showAttachmentsModal = (editor, store = null) => {
  currentAttachmentIdsStore = store; // allow temporary passing of store to be used in addOrRemoveAttachment - will be reset on modal close
  $("#attachFileModal").attr("data-id", editor.settings.id).modal("show");
};

export const initializeAttachments = () => {
  attachmentsStore.subscribe((data) => {
    allAttachments = data || [];
    refreshAttachments();
  });

  $("body").append(`
    <div class="modal fade" role="dialog" tabindex="-1" id="attachFileModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div id="attachFileModalContent" class="modal-content">
          <div class="modal-header" style="padding-bottom: 0">
            <h5 class="modal-title">Attach a file</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><i class="fa-regular fa-xmark fa-sm"></i></span>
            </button>
          </div>
          <div id="attachmentBody" class="modal-body">
            <div id="selectAttachments">
              <label style="font-size: 0.9rem" class="mb-1" for="selectAttachmentsButton">Select a file (up to 20MB)</label>
              <div class="d-flex">
                <button id="selectAttachmentsButton" class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">
                  Loading...
                  <span class="caret"></span>
                </button>
                <div id="fileAttachmentUpload">
                  <label for="attachmentUpload">
                    <i class="fa-solid fa-cloud-arrow-up"></i>
                  </label>
                  <input style="display: none" id="attachmentUpload" type="file" />
                </div>
                <ul class="dropdown-menu"></ul>
              </div>
            </div>
            <div class="align-items-center mt-3">
              <ul class="nav nav-tabs mb-3" role="tablist" id="nav-tabs">
                <li id="insertHyperlinkTab" class="nav-item" role="presentation">
                  <a class="nav-link active" href="#insertHyperlink" data-toggle="tab">Insert as hyperlink</a>
                </li>
                <li style="display:none" id="insertAttachmentTab" class="nav-item" role="presentation">
                  <a class="nav-link" href="#insertAttachment" data-toggle="tab">Insert as file</a>
                </li>
              </ul>
            </div>
            <div id="insertOptions" class="tab-content">
              <div id="insertHyperlink" class="tab-pane active" role="tabpanel">
                <div class="input-group mb-2">
                  <div class="input-group round-right">
                    <div class="input-group-prepend">
                      <span class="input-group-text">Hyperlink text</span>
                    </div>
                    <input
                      placeholder='e.g. "Click here to open file"'
                      class="form-control"
                      type="text"
                      id="hyperlinkText"
                      style="color: #47567b"
                    />
                  </div>
                </div>
              </div>
              <div id="insertAttachment" class="tab-pane" role="tabpanel">
                <p>Your file will be inserted into this email as an attachment.</p>
                <p style="color: var(--danger, red)">Attaching files may affect deliverability as some email providers are more likely to mark emails with attachments as spam. Be cautious when attaching unusual file types, as they may not be accepted by your email service provider.
                </p>
              </div>
            </div>
            <div class="float-right mt-3">
              <button class="btn btn-primary hidden" id="submitAttachFileModal" type="button">Insert</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  `);

  if (window.location.pathname !== "/profile") $("#insertAttachmentTab").show();

  $(document).on("click", ".close-icon[data-attachment-id]", (e) => {
    addOrRemoveAttachment({
      event: e,
      type: "remove",
      fileId: $(e.target).data("attachment-id"),
      targetTemplateId: $(e.target).data("template-id"),
    });
  });

  $("#submitAttachFileModal").click(() => {
    const fileSizeInMB = currentFile.size / (1024 * 1024);
    const activeTab = $("#insertOptions .tab-pane.active").attr("id");
    if (fileSizeInMB > 20 && activeTab === "insertAttachment") {
      showToast({
        title: "Email attachments cannot exceed 20MB",
        subtitle: "Please insert a hyperlink instead",
        type: "danger",
      });
      return;
    }
    if (activeTab === "insertHyperlink")
      insertLinkedText(currentFile.url, $("#hyperlinkText").val());
    if (activeTab === "insertAttachment") {
      const idString = $("#attachFileModal").attr("data-id");
      const lastDashIndex = idString.lastIndexOf("-");

      addOrRemoveAttachment({
        type: "add",
        fileId: currentFile.attachmentId,
        targetTemplateId:
          lastDashIndex === -1 ? idString : idString.slice(0, lastDashIndex),
      });
    }
  });

  $(document).on("change", "#attachmentUpload", (event) => {
    const file = event.target.files[0];
    if (file.size / (1024 * 1024) > 20) {
      showToast({
        title: "Files cannot exceed 20MB",
        subtitle: "Please try again with a smaller file",
        type: "danger",
      });
      return;
    }
    const reader = new FileReader();

    reader.onload = () => {
      const id = `blobid${Date.now()}`;
      const { blobCache } = tinymce.activeEditor.editorUpload;
      const base64 = reader.result.split(",")[1];
      const blobInfo = blobCache.create(id, file, base64);
      blobCache.add(blobInfo);
      const blob = blobInfo.blob();
      const data = {
        data: `data:${blob.type};base64,${blobInfo.base64()}`,
        filename: blob.name,
        isImageUpload: false,
      };
      const inputHtml = $("#selectAttachmentsButton");
      $("#LoadingDiv").removeClass("invisible");
      inputHtml.text("Loading...").prop("disabled", true);

      largePOST({
        url: "/api/attachments/save",
        data: JSON.stringify(data),
        success: () => {
          refreshAttachments();
          $("#LoadingDiv").addClass("invisible");
          showToast({
            title: `Successfully uploaded ${file.name}`,
            type: "success",
          });
          inputHtml.prop("disabled", false);
        },
        error: () => {
          refreshAttachments();
          $("#LoadingDiv").addClass("invisible");
          inputHtml.prop("disabled", false);
        },
      });
    };
    reader.readAsDataURL(file);
  });

  $("#attachFileModal").on("shown.bs.modal", async () => {
    await attachmentsStore.once();
    refreshAttachments();
  });

  $("#attachFileModal").on("hidden.bs.modal", () => {
    currentAttachmentIdsStore = null;
    $("#LoadingDiv").addClass("invisible");
  });
};
